"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabs = void 0;
exports.tabs = [
    { slug: 'leaderBoard', index: 0 },
    { slug: 'tournamentPrizes', index: 1 },
    { slug: 'rules', index: 2 },
];
